import { makeHTTPProvider } from 'shared/infra/providers';

const fetchCoupon = async (cupom, unidade, produtos) => {
  const url = `/coupon/${cupom}?unidade=${unidade || 40}&produtos=${produtos}`;

  return makeHTTPProvider()
    .get(url)
    .then(data => {
      if (!data) return null;

      return {
        id: data.id,
        codigo: data.codigoCupom,
        dataCriacao: data.dataCriacao,
        valorDesconto: data.valor,
        percentualDesconto: data.percentual,
      };
    });
};

export default fetchCoupon;
